import { useRecoilValue } from "recoil";
import { taskCounterSubmissionSearchAtom } from "../miscellaneous/taskCounterSubmissionSearchAtom";

export const useTaskCounterSubmissionSearchValue = () => {
  return useRecoilValue(taskCounterSubmissionSearchAtom);
};
